import goodsIndex from '@/pages/goods/index.vue'
import goodsClass from '@/pages/goods/goodsClass.vue' 
import goodsList from '@/pages/goods/goodsList.vue'
import goodsDetail from '@/pages/goods/goodsDetail.vue'

const appRoutes = [{
	path: '/goods',
	redirect: '/goods/goodsClass',
	component: goodsIndex,
	children: [{
		path: 'goodsClass',
    name: 'goodsClass',
		component: goodsClass
	},{
		path: 'goodsList',
    name: 'goodsList',
		component: goodsList
	},{
		path: 'goodsDetail',
    name: 'goodsDetail',
		component: goodsDetail
	}]
}]
export default appRoutes

